export function getSelector(...keys) {
    return (keys || []).join('-');
}
